import styled, { css } from "styled-components";
export const MembershipViewWrapper = styled.div`
  margin: 12px 50px 0;
  border: 1px solid ${(p) => p.theme["color-line-1"]};
  border-radius: 6px;
  position: relative;
  height: calc(100vh - 170px);
  min-height: 479px;
  background: ${(p) => p.theme["theme-1"]};
  pointer-events: auto;
`;

export const MembershipContentWrapper = styled.div`
  display: flex;
  height: 100%;
`;
export const RightContent = styled.div`
  width: 220px;
`;

export const LeftContent = styled.div`
  flex: 1 1 0%;
  overflow: hidden;
`;

export const MembershipCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 14px;
  background: ${(p) => p.theme["gradient-fill-4"]};

  .privilege-bg {
    margin: 4px 0 14px;
    width: 297px;
    height: 20px;
  }
`;
export const MemberShipFeatureGroupWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 27px;
  box-sizing: border-box;
`;
export const MembershipFeature = styled.div`
  svg {
    width: 26px;
  }
  p {
    margin: 0;
  }
  .title {
    color: #4a94fd;
    font-size: 12px;
    font-weight: 600;
  }
  .tip {
    color: #7b97d4;
    font-weight: 400;
    font-size: 10px;
    margin-top: 4px;
  }
`;
export const MembershipContent = styled.div`
  margin: 16px 13px;
`;
export const MembershipLevelCardGroup = styled.div`
  margin-top: 16px;
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
`;

const beforeCss = css`
  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    padding: 2px;
    box-sizing: border-box;
    background: linear-gradient(
      129.05deg,
      #3d44ff 2.12%,
      #6a24ff 54.24%,
      #8952ff 88.83%
    );
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
  }
`;

export const MembershipLevelCard = styled.div`
  width: 156px;
  height: 124px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: 14px;
  position: relative;
  cursor: pointer;
  border-radius: 6px;
  background: ${(p) => p.theme["color-fill-2"]};
  box-shadow: inset 0 0 0 1px ${(p) => p.theme["color-line-2"]};
  z-index: 2;
  &.active {
    background: ${(p) => p.theme["gradient-fill-5"]};
    ${beforeCss};
  }
  :hover {
    ${beforeCss}
  }
`;
export const MonthWrapper = styled.div`
  color: ${(p) => p.theme["color-text-8"]};
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  line-height: 25px;
`;
export const PriceWrapper = styled.div`
  background: linear-gradient(180deg, #2571ff 22.64%, #00e2ff 119.3%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  line-height: 41px;
  height: 41px;
  .symbol {
    font-size: 16px;
    font-weight: 500;
  }
`;
export const OriginalPrice = styled.div`
  color: ${(p) => p.theme["color-text-8"]};
  opacity: 0.7;
  font-size: 12px;
  text-decoration: line-through;
  text-align: center;
  margin-top: -6px;
`;
export const PricePerMonthWrapper = styled.div`
  height: 30px;
  line-height: 30px;
  background: ${(p) => p.theme["color-fill-7"]};
  box-sizing: border-box;
  color: ${(p) => p.theme["color-text-8"]};
  font-size: 12px;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: auto;
  margin: 1px;
  border-radius: 0 0 6px 6px;
  z-index: -1;
  &.active {
    background: linear-gradient(
      129.05deg,
      #3d44ff 2.12%,
      #6a24ff 54.24%,
      #8952ff 88.83%
    );
    color: #ffffffe5;
    font-weight: 600;
  }
`;

export const TopIcon = styled.div`
  width: 130px;
  height: 24px;
  position: absolute;
  top: 0;
  left: 0;
  img {
    width: 130px;
  }
`;

export const VipTitle = styled.div`
  color: ${(p) => p.theme["color-text-1"]};
  font-size: 14px;
  font-weight: 600;
`;
